(function () {
  'use strict';

  angular.module('lif.controllers').controller('searchController', searchController);
  searchController.$inject = ['$scope', '$window', '$timeout', '$location', 'bootstrappedNavigationModel'];

  function searchController($scope, $window, $timeout, $location, bootstrappedNavigationModel) {
    var vm = this;
    vm.searchResults = [];
    vm.latestSuccessfulSearchString = "";
    vm.isBusy = false;
    var searchPage = bootstrappedNavigationModel.searchPage;
    var protocol = $location.protocol();
    var host = $location.host();
    var baseUrl = protocol + "://" + host + searchPage;
    vm.showSearch = true;

    vm.searchAndDisplayInNewPage = function (searchString) {
      if (searchString === undefined || searchString === '') {
        return;
      }

      var searchUrl = baseUrl + "?q=" + searchString;
      $window.location.href = searchUrl;
    };

    var timeout;

    vm.search = function () {
      if (timeout) $timeout.cancel(timeout);
      vm.isBusy = true;
      vm.showSearch = true;
      timeout = $timeout(function () {
        var searchString = vm.searchString;

        if (searchString === undefined || searchString == null || searchString === '') {
          return;
        }

        var searchUrl = baseUrl + "quicksearch" + "?search=" + searchString;
        $.get(searchUrl, function (data) {
          var result = JSON.parse(data);
          vm.searchResults = result.Hits;
          vm.isBusy = false;
        }).then(function () {
          $scope.$apply();
        });
      }, 250);
    };

    vm.navigateToLink = function (link) {
      var getByIdUrl = baseUrl + "geturlbyid" + "?id=" + link.DocumentId;
      $.get(getByIdUrl, function (url) {
        $window.location.href = url;
      });
    };

    vm.onSearchClicked = function () {
      vm.showSearch = true;
    };

    $('html').click(function (event) {
      if (!$(event.target).is('#search-container') && !$(event.target).is('#search-input')) {
        vm.showSearch = false;
        $scope.$apply();
      }
    });
    $('#search-container').click(function (event) {
      event.stopPropagation();
    });
  }

  ;
})();